import objectPath from 'object-path'
import { Button } from 'react-bootstrap'
import moment from 'moment'
import Swal from 'sweetalert2'
import PNotify from 'pnotify/dist/es/PNotify'
import httpClient from 'utility/httpClient.util'
import { checkConditionApi } from 'designer/component/action/Api'
import { goToForm, goToPage, goToUrl, goToModal } from '../Action'
import Icon from '../../Icon'
import { getCheckValue } from 'designer/component/action/Data'
import { Chip } from '@material-ui/core'
import { checkTableColumnCondition } from '../action/Condition'

const doBeforeAction = (
  action,
  rowData,
  formData,
  allParams,
  location,
  history,
  designContext,
  historyContext,
  uischema,
  setModalAction,
  renderTableData,
  isEditable,
) => {
  let beforeAction = objectPath.get(action, 'beforeAction') || {}
  if (beforeAction.isEnabled) {
    let actionName = objectPath.get(beforeAction, 'name')
    if (actionName === 'alert') {
      let alert = objectPath.get(action, 'beforeAction.alert') || {}
      Swal.fire(alert).then((result) => {
        if (result.isConfirmed) {
          if (alert.confirmAlert) {
            Swal.fire(alert.confirmTitle, alert.confirmText, 'success')
          }
          doAction(
            action,
            rowData,
            formData,
            allParams,
            location,
            history,
            designContext,
            historyContext,
            uischema,
            setModalAction,
            renderTableData,
            isEditable,
          )
        } else if (result.isDenied) {
          if (alert.denyAlert) {
            Swal.fire(alert.denyTitle, alert.denyText, 'info')
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          if (alert.cancelAlert) {
            Swal.fire(alert.cancelTitle, alert.cancelText, 'error')
          }
        }
      })
    }
  } else {
    doAction(
      action,
      rowData,
      formData,
      allParams,
      location,
      history,
      designContext,
      historyContext,
      uischema,
      setModalAction,
      renderTableData,
      isEditable,
    )
  }
}

const setRequestData = (action, rowData, formData) => {
  let requestData = {}
  let { customData = [] } = action
  customData.forEach(({ request, propType, value, key = '' }) => {
    if (propType === 'table') {
      let value =
        objectPath.get(formData, request) || objectPath.get(rowData, key)
      objectPath.set(requestData, request, value)
    } else if (propType === 'input') {
      let value = objectPath.has(formData, key)
        ? objectPath.get(formData, key)
        : objectPath.get(formData, request)
      objectPath.set(requestData, request, value)
    } else if (propType === 'system') {
      let value = objectPath.get(formData, key)
      objectPath.set(requestData, request, value)
    } else if (propType === 'custom') {
      value = getCheckValue(value)
      objectPath.set(requestData, request, value)
    } else if (propType === 'dateTime') {
      let now = null
      if (value === 'currentDate') {
        now = moment().format('YYYY-MM-DD')
      } else if (value === 'currentTime') {
        now = moment().format('HH:mm:ss')
      } else if (value === 'currentDateTime') {
        now = moment().format('YYYY-MM-DD HH:mm:ss')
      }
      objectPath.set(requestData, request, now)
    }
  })
  console.log('requestData', requestData)
  return requestData
}

const setApi = (
  {
    apiType,
    api = '',
    service = '',
    endpoint = '',
    pathParams = [],
    queryParams = [],
  },
  rowData,
  formData,
  allParams,
  url,
) => {
  if (url) {
    api = url
  } else if (apiType === 'internal') {
    api = service + endpoint
  }

  if (pathParams) {
    pathParams.forEach(
      ({ param, key, propType = '', value, prefixValue = '' }) => {
        if (!param) return
        if (propType === 'table') {
          value = objectPath.get(rowData, key) || null
        } else if (propType === 'urlParam') {
          value = objectPath.get(allParams, key) || null
        } else if (
          propType === 'input' ||
          propType === 'formData' ||
          propType === 'system'
        ) {
          value =
            objectPath.get(formData, key) ||
            objectPath.get(formData, param) ||
            null
        }
        if (value && prefixValue && !value.startsWith(prefixValue)) {
          value = prefixValue + value
        }
        if (api.search(`:${param}`) > -1) {
          api = api.replace(`:${param}`, value)
        }
        if (api.search(`{${param}}`) > -1) {
          api = api.replace(`{${param}}`, value)
        }
      },
    )
  }

  if (queryParams) {
    let query = []
    queryParams.forEach(
      ({
        param,
        key,
        propType = '',
        value,
        prefixValue = '',
        paramList = [],
      }) => {
        if (!param) return
        if (propType === 'table') {
          value = objectPath.get(rowData, key) || null
        } else if (propType === 'urlParam') {
          value = objectPath.get(allParams, key) || null
        } else if (
          propType === 'input' ||
          propType === 'formData' ||
          propType === 'system'
        ) {
          value =
            objectPath.get(formData, key) ||
            objectPath.get(formData, param) ||
            null
        } else if (propType === 'postgrestql') {
          let paramValue = value
          let stringValue = ''
          paramList.forEach(({ param, key, propType = '', value }) => {
            if (propType === 'table') {
              stringValue = objectPath.get(rowData, key) || null
            } else if (propType === 'urlParam') {
              stringValue = objectPath.get(allParams, key) || null
            } else if (propType === 'input') {
              stringValue =
                objectPath.get(formData, key) ||
                objectPath.get(formData, param) ||
                value
            } else if (propType === 'custom') {
              stringValue = value
            }
            if (stringValue === undefined) {
              stringValue = ''
            }
            value = paramValue.replace(`$${param}`, stringValue)
          })
        }
        if (value === null || value === '' || value === undefined) return
        if (prefixValue && !value.startsWith(prefixValue)) {
          value = prefixValue + value
        }
        query.push(`${param}=${value}`)
      },
    )
    console.log('api', api)

    let connect = api.indexOf('?') > -1 ? '&' : '?'
    api = query.length > 0 ? api + connect + query.join('&') : api
  }

  return api
}

const postData = async (action, rowData, formData, allParams) => {
  // set api
  let api = setApi(action, rowData, formData, allParams)
  if (!api) return
  // set request body
  let requestData = setRequestData(action, rowData, formData)
  // set headers
  let { headers = [] } = action
  let config = {}
  if (headers.length > 0) {
    headers.forEach(({ key, value }) => {
      if (key) {
        objectPath.set(config, `headers.${key}`, value)
      }
    })
  }
  // send request
  let response = await httpClient
    .post(api, requestData, config)
    .then((data) => data)
    .catch(function (error) {
      if (error.response) {
        return {
          status: error.response.status,
          message: error.response.data,
          data: null,
        }
      }
    })
  return response
}

const putData = async (action, rowData, formData, allParams) => {
  // set api
  let api = setApi(action, rowData, formData, allParams)
  if (!api) return
  // set request body
  let requestData = setRequestData(action, rowData, formData)
  // set headers
  let { headers = [] } = action
  let config = {}
  if (headers.length > 0) {
    headers.forEach(({ key, value }) => {
      if (key) {
        objectPath.set(config, `headers.${key}`, value)
      }
    })
  }
  // send request
  let response = await httpClient
    .put(api, requestData, config)
    .then((data) => data)
    .catch(function (error) {
      if (error.response) {
        return {
          status: error.response.status,
          message: error.response.data,
          data: null,
        }
      }
    })

  return response
}

const patchData = async (action, rowData, formData, allParams) => {
  // set api
  let api = setApi(action, rowData, formData, allParams)
  if (!api) return
  // set request body
  let requestData = setRequestData(action, rowData, formData)
  // set headers
  let { headers = [] } = action
  let config = {}
  if (headers.length > 0) {
    headers.forEach(({ key, value }) => {
      if (key) {
        objectPath.set(config, `headers.${key}`, value)
      }
    })
  }
  // send request
  let response = await httpClient
    .patch(api, requestData, config)
    .then((data) => data)
    .catch(function (error) {
      if (error.response) {
        return {
          status: error.response.status,
          message: error.response.data,
          data: null,
        }
      }
    })

  return response
}

const deleteData = async (action, rowData, formData, allParams) => {
  // set api
  let api = setApi(action, rowData, formData, allParams)
  if (!api) return
  // set request body

  let { headers = [] } = action
  let config = {}
  if (headers.length > 0) {
    headers.forEach(({ key, value }) => {
      if (key) {
        objectPath.set(config, `headers.${key}`, value)
      }
    })
  }

  let response = await httpClient
    .delete(api, config)
    .then((data) => data)
    .catch(function (error) {
      if (error.response) {
        return {
          status: error.response.status,
          message: error.response.data,
          data: null,
        }
      }
    })
  return response
}

const getData = async (action, rowData, formData, allParams) => {
  let {
    responseDataType,
    customName,
    dataKey = '',
    dataTable,
    headers = [],
  } = action

  let api = setApi(action, rowData, formData, allParams)
  if (!api) return

  // set headers
  let config = {}
  if (headers.length > 0) {
    headers.forEach(({ key, value }) => {
      if (key) {
        objectPath.set(config, `headers.${key}`, value)
      }
    })
  }
  // send request
  let response = await httpClient
    .get(api, config)
    .then(({ data }) => {
      return { status: 200, data: data, message: 'success' }
    })
    .catch(function (error) {
      if (error.response) {
        return {
          status: error.response.status,
          message: error.response.data,
          data: null,
        }
      }
    })
  return response
}

const crud = async (
  action,
  rowData,
  formData,
  allParams,
  location,
  designContext,
) => {
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  let tabParamActive = objectPath.get(designContext, `tabParamActive`) || {}
  let promiseList = []
  let apiGroup = objectPath.get(action, 'crud.apiGroup') || []

  let filterApi = []
  filterApi = apiGroup.filter((item) => {
    if (item.method === 'get') {
      return checkConditionApi(
        item,
        allParams,
        formData,
        datasourceValue,
        tabParamActive,
      )
    }
    if (item.method === 'post') {
      return checkConditionApi(
        item,
        allParams,
        formData,
        datasourceValue,
        tabParamActive,
      )
    }
    if (item.method === 'put') {
      return checkConditionApi(
        item,
        allParams,
        formData,
        datasourceValue,
        tabParamActive,
      )
    }
    if (item.method === 'patch') {
      return checkConditionApi(
        item,
        allParams,
        formData,
        datasourceValue,
        tabParamActive,
      )
    }
    if (item.method === 'delete') {
      return checkConditionApi(
        item,
        allParams,
        formData,
        datasourceValue,
        tabParamActive,
      )
    }
    return false
  })

  filterApi.map(async (item) => {
    let promise = new Promise(async (resolve, reject) => {
      let response = {}
      let data = null
      let status = null
      let message = ''

      if (item.method === 'get') {
        response = await getData(item, rowData, formData, allParams)
      } else if (item.method === 'post') {
        response = await postData(item, rowData, formData, allParams)
      } else if (item.method === 'put') {
        response = await putData(item, rowData, formData, allParams)
      } else if (item.method === 'patch') {
        response = await patchData(item, rowData, formData, allParams)
      } else if (item.method === 'delete') {
        response = await deleteData(item, rowData, formData, allParams)
      }

      data = response.data
      message = response.message
      status = response.status

      if (status >= 400) {
        reject({
          status: status,
          data: null,
          message: message,
          api: item.api,
          apiName: item.apiName,
        })
      } else {
        resolve({
          status: status,
          data: data,
          message: message,
          api: item.api,
          apiName: item.apiName,
        })
      }
    })
      .then((response) => response)
      .catch((error) => error)
    promiseList.push(promise)
  })

  return await Promise.all(promiseList)
}

const print = (action, rowData, formData, allParams) => {
  let print = objectPath.get(action, 'print')
  let url = objectPath.get(print, 'url')
  let api = setApi(print, rowData, formData, allParams, url)
  if (api) {
    window.open(api, '_blank')
  }
}

const getAction = (
  action,
  rowData,
  formData,
  allParams,
  location,
  history,
  designContext,
  historyContext,
  uischema,
  setModalAction,
  renderTableData,
  isEditable,
) => {
  let tableAction = action?.action

  switch (action.name) {
    case 'goToForm':
      return goToForm(
        tableAction,
        history,
        rowData,
        designContext,
        historyContext,
      )
    case 'goToPage':
      return goToPage(
        tableAction,
        history,
        rowData,
        designContext,
        historyContext,
      )
    case 'goToUrl':
      return goToUrl(tableAction, uischema, rowData, designContext)
    case 'openModal':
      setModalAction(tableAction)
      return goToModal(
        tableAction,
        objectPath.get(tableAction, 'modal.key'),
        rowData,
        designContext,
        uischema,
      )
    case 'crud':
      return crud(
        tableAction,
        rowData,
        formData,
        allParams,
        location,
        designContext,
      )
    case 'print':
      return print(tableAction, rowData, formData, allParams)
    case 'refreshTable':
      return renderTableData(uischema, false, true)
    default:
      return
  }
}

const setNotification = (afterAction, response) => {
  let {
    status,
    data = null,
    message = '',
    api = '',
    apiName = '',
  } = response || {}
  if (afterAction.isNotified) {
    if (status >= 200 && status < 300) {
      let notice = PNotify.success({
        title: afterAction.notifySuccessTitle || 'Success',
        text: afterAction.notifySuccessText,
        icon: 'fas fa-check-circle fa-xl',
      })
      notice.on('click', function () {
        notice.close()
      })
      console.log(`API Name: ${apiName}`)
    } else {
      let notice = PNotify.error({
        title: afterAction.notifyErrorTitle || 'Error',
        text: JSON.stringify(message, null, 2) || afterAction.notifyErrorText,
        icon: 'fas fa-exclamation-circle fa-xl',
      })
      notice.on('click', function () {
        notice.close()
      })
      console.error(`Error API Name: ${apiName}`)
    }
  }
}

const doAction = (
  action,
  rowData,
  formData,
  allParams,
  location,
  history,
  designContext,
  historyContext,
  uischema,
  setModalAction,
  renderTableData,
  isEditable,
) => {
  const promise1 = new Promise(async (resolve, reject) => {
    let response = await getAction(
      action,
      rowData,
      formData,
      allParams,
      location,
      history,
      designContext,
      historyContext,
      uischema,
      setModalAction,
      renderTableData,
      isEditable,
    )
    let afterAction = objectPath.get(action, 'afterAction') || {}
    if (Array.isArray(response)) {
      response.forEach((response = {}) => {
        let { status, data = null } = response
        if (status === null) return
        setNotification(afterAction, response)
      })
    } else {
      let { status, data = null } = response || {}
      if (status === null) return
      setNotification(afterAction, response)
    }
    if (afterAction?.isEnabled) {
      let actionList = objectPath.get(afterAction, 'action') || []
      actionList.forEach(async (action) => {
        await getAction(
          action,
          rowData,
          formData,
          allParams,
          location,
          history,
          designContext,
          historyContext,
          uischema,
          setModalAction,
          renderTableData,
          isEditable,
        )
        console.log('afterAction', action.name)
      })
    }
    resolve(response || {})
  })

  promise1.then((response) => {
    let afterSuccess = objectPath.get(action, 'afterSuccess') || {}
    if (afterSuccess?.isEnabled && Array.isArray(response)) {
      let checkError = response.filter(({ status }) => {
        if (status >= 200 && status < 300) {
          return false
        }
        return true
      })
      if (checkError.length === 0) {
        let actionList = objectPath.get(afterSuccess, 'action') || []
        actionList.forEach(async (action) => {
          await getAction(
            action,
            rowData,
            formData,
            allParams,
            location,
            history,
            designContext,
            historyContext,
            uischema,
            setModalAction,
            renderTableData,
            isEditable,
          )
          console.log('afterSuccess', action.name)
        })
      }
    }
  })
}

const renderButton = ({
  column,
  formData,
  allParams,
  location,
  history,
  designContext,
  historyContext,
  uischema,
  setModalAction = () => {},
  renderTableData = () => {},
  setIsClickButton = () => {},
  isEditable,
  stateParent,
}) => {
  const initialColor = column.buttonColor ? column.buttonColor : '#4099ff'
  const { conditions = [] } = column

  const [, setDataRowSelected = () => {}] =
    stateParent?.dataRowSelected ?? []

  const checkCondition = (condition, rowData) => {
    return checkTableColumnCondition({
      condition,
      column,
      rowData,
      formData,
      designContext,
    })
  }

  const style = {
    color: initialColor,
    borderColor: column.buttonText ? initialColor : 'transparent',
    backgroundColor: 'transparent',
    padding: column.buttonText ? '4px 8px' : '0',
  }

  if (isEditable) {
    return (editProps) => {
      let rowData = editProps?.rowData || editProps
      let isHideButton = conditions.find(
        (condition) =>
          condition.actionColumn === 'hide' && checkCondition(condition, rowData),
      )
      if (isHideButton) return null

      let foundCondition = conditions.find((condition) =>
        checkCondition(condition, rowData),
      )
      if (foundCondition?.isChangeToStatus) {
        return (
          <Chip
            label={foundCondition?.changeToStatus}
            style={{
              backgroundColor: foundCondition?.statusChipColor,
              color: foundCondition?.statusColor || 'white',
              fontSize: '14px',
            }}
          />
        )
      }
      return (
        <Button
          className="d-flex hover-shadow"
          style={style}
          variant="outline-primary"
          onClick={() => {
            setDataRowSelected(rowData)
            setIsClickButton(true)
            doBeforeAction(
              column,
              rowData,
              formData,
              allParams,
              location,
              history,
              designContext,
              historyContext,
              uischema,
              setModalAction,
              renderTableData,
              isEditable,
            )
          }}
        >
          <span
            className={column.buttonText ? 'mr-1' : ''}
            style={{ top: '-2px', position: 'relative' }}
          >
            <Icon
              iconName={column.buttonIcon}
              size={column.buttonText ? '14px' : '20px'}
            />
          </span>
          {column.buttonText}
        </Button>
      )
    }
  }

  return (rowData) => {
    let isHideButton = conditions.find(
      (condition) =>
        condition.actionColumn === 'hide' && checkCondition(condition, rowData),
    )
    if (isHideButton) return null

    let foundCondition = conditions.find((condition) =>
      checkCondition(condition, rowData),
    )

    if (foundCondition?.isChangeToStatus) {
      return (
        <Chip
          label={foundCondition?.changeToStatus}
          style={{
            backgroundColor: foundCondition?.statusChipColor,
            color: foundCondition?.statusColor || 'white',
            fontSize: '14px',
          }}
        />
      )
    }

    return (
      <Button
        className="d-flex hover-shadow"
        style={style}
        variant="outline-primary"
        onClick={() => {
          setIsClickButton(true)
          doBeforeAction(
            column,
            rowData,
            formData,
            allParams,
            location,
            history,
            designContext,
            historyContext,
            uischema,
            setModalAction,
            renderTableData,
            isEditable,
          )
        }}
      >
        <span
          className={column.buttonText ? 'mr-1' : ''}
          style={{ top: '-2px', position: 'relative' }}
        >
          <Icon
            iconName={column.buttonIcon}
            size={column.buttonText ? '14px' : '20px'}
          />
        </span>
        {column.buttonText}
      </Button>
    )
  }
}

export default renderButton
